import AwesomeDebouncePromise from 'awesome-debounce-promise';
import ApiService from '../services/apiService';

export const indexTechnicalIncidentsRequest = ({ dispatch, params = {}, successCallback, callback }) =>
  ApiService.request('get', `/technical_incidents`, {
    dispatch,
    params,
    successCallback,
    callback
  });

export const exportTechnicalIncidentsRequest = ({
  dispatch,
  format,
  responseType = 'text',
  params = {},
  callback,
  successCallback
}) =>
  ApiService.request('get', `/technical_incidents/export_report${format}`, {
    dispatch,
    params,
    responseType,
    successCallback,
    callback
  });

export const debounceIndexTechnicalIncidentsRequest = AwesomeDebouncePromise(indexTechnicalIncidentsRequest, 300);
